<template>

    <div>

        <h1 class="mt-4" v-if="subscription_name == ''"><a href="/subscriptions">Abonnemang</a> / Nytt abonnemang</h1>
        <h1 class="mt-4" v-if="subscription_name != ''"><a href="/subscriptions">Abonnemang</a> / {{ subscription_name }}</h1>

        <div class="summary-container">
            <div class=""></div>
        </div>

        <div class="tabs-container">
            <div class="tab" :class="{ 'active' : activeTab == 'settings' }" @click="loadView('settings')">Inställningar</div>
            <div class="tab" :class="{ 'active' : activeTab == 'prices' }" @click="loadView('prices')">Priser</div>
        </div>

        <div class="content-container">

            <transition name="fade" mode="out-in">
                <settings :subscription_id="subscription_id" v-if="activeTab == 'settings'"></settings>
                <prices :subscription_id="subscription_id" v-if="activeTab == 'prices'"></prices>
            </transition>

        </div>

    </div>

</template>

<script>

import settings from './settings.vue'
import prices from './prices.vue'

import tabber from '../../../mixins/tabber'

export default {

    components: {
        settings,
        prices
    },

    mixins: [
        tabber
    ],

    props: {
        subscription_id: {
            required: false
        },
        subscription_name: {
            required: false
        }
    },

    data () {
        return {
            defaultTab: 'settings'
        }
    },

    methods: {

    }

}
</script>

<style type="text/css">

    /* --- Fade transition --- */
    .fade-enter-active, .fade-leave-active {
      transition: all 350ms;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
</style>
